export interface DownloadFile {
  filename: string;
  url: string;
  size: number;
  sha512: string;
  label: string;
  sublabel: string;
}

export interface PlatformDownload {
  version: string;
  files: DownloadFile[];
}

export interface DistributionDownload {
  id: string;
  name: string;
  description: string;
  version: string;
  releaseDate: string;
  platforms: {
    windows?: PlatformDownload;
    macos?: PlatformDownload;
    linux?: PlatformDownload;
  };
}

export interface DownloadsResponse {
  distributions: DistributionDownload[];
}

export async function fetchDownloads(): Promise<DownloadsResponse> {
  const response = await fetch("/api/downloads");
  if (!response.ok) {
    throw new Error(`Failed to fetch downloads: ${response.status} ${response.statusText}`);
  }
  return response.json();
}

export function formatSize(bytes: number): string {
  if (bytes === 0) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const size = bytes / Math.pow(1024, i);
  return `${Math.round(size)} ${units[i]}`;
}

export const systemRequirements = {
  windows: {
    os: "Windows 10 or later (64-bit)",
    ram: "4 GB RAM minimum",
    disk: "200 MB free disk space",
    notes: "Administrator privileges may be required for installation",
  },
  macos: {
    os: "macOS 10.15 (Catalina) or later",
    ram: "4 GB RAM minimum",
    disk: "200 MB free disk space",
    notes: "Apple Silicon and Intel Macs are both supported",
  },
  linux: {
    os: "Modern Linux distribution (glibc 2.31+)",
    ram: "4 GB RAM minimum",
    disk: "200 MB free disk space",
    notes: "AppImage requires no installation. .deb requires Debian/Ubuntu-based distro",
  },
};
